import { createReducer as createRtkReducer } from '@reduxjs/toolkit';
import breakpointCalculator from './breakpointCalculator';

export default function createReducer(headerInfo) {
    const serverHeight = 800; // This could also be made dependend on the device type from the headerInfo
    let serverWidth = 1200;

    if (headerInfo && headerInfo.md) {
        if (headerInfo.md.phone()) {
            serverWidth = 576;
        } else if (headerInfo.md.tablet()) {
            serverWidth = 768;
        }
    }

    const serverBreakPoints = breakpointCalculator(serverWidth, serverHeight);
    const initialState = {
        serverHeight,
        serverWidth,
        serverBreakPoints,
        serverClientWidthDiff: null,
        width: serverWidth,
        height: serverHeight,
        isExtraSmall: serverBreakPoints.isExtraSmall,
        isSmall: serverBreakPoints.isSmall,
        isMedium: serverBreakPoints.isMedium,
        isLarge: serverBreakPoints.isLarge,
        isExtraLarge: serverBreakPoints.isExtraLarge,
    };

    return createRtkReducer(initialState, (builder) => {
        builder.addCase('@@BREAKPOINT_CHANGE', (state, action) => {
            const breakPoints = breakpointCalculator(action.width, action.height);
            let serverClientWidthDiff = state.serverClientWidthDiff;

            if (serverClientWidthDiff === null && action.width) {
                // calculate the difference between server and client width
                // values in percent ( 0 = no difference, -10 = 10% smaller, 10 = 10% bigger, ...)
                serverClientWidthDiff = ((action.width / serverWidth) * 100) - 100;
            }

            state.height = action.height;
            state.width = action.width;
            state.serverClientWidthDiff = serverClientWidthDiff;
            state.isExtraSmall = breakPoints.isExtraSmall;
            state.isSmall = breakPoints.isSmall;
            state.isMedium = breakPoints.isMedium;
            state.isLarge = breakPoints.isLarge;
            state.isExtraLarge = breakPoints.isExtraLarge;
        });
    });
}
